import React from 'react';
import { Sheet, UseSheetReturnType } from '../../../../mobile/structural/sheet';
import { useTranslator } from '../../../i18n/useTranslator';
import BoardLinkSheetContent from './BoardLinkSheetContent';
import { BoardLinkSearchItem } from './boardLinkTypes';

type BoardLinkSheetProps = {
    sheetProps: UseSheetReturnType;
    onSelect: (item: BoardLinkSearchItem) => boolean;
    onPasteBoardLink: (text: string) => boolean;
};

const BoardLinkSheet: React.FC<BoardLinkSheetProps> = ({ sheetProps, onSelect, onPasteBoardLink }) => {
    const translate = useTranslator('toolbar', 'tools.editing.insertMenu');

    const actionAndClose =
        <T,>(action: (param: T) => boolean) =>
        (param: T) => {
            const didInsert = action(param);
            if (!didInsert) return false;

            sheetProps.closeSheet({ dismissFlow: true });
            return true;
        };

    return (
        <Sheet className="MobileInsertBoardLinkSheet" {...sheetProps} defaultSnapPoint={0.5} snapPoints={[0.5, 1]}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Header>
                    <Sheet.Heading>{translate('boardLink')}</Sheet.Heading>
                    <Sheet.DoneButton />
                </Sheet.Header>
                <BoardLinkSheetContent
                    onSelect={actionAndClose(onSelect)}
                    onPasteBoardLink={actionAndClose(onPasteBoardLink)}
                />
            </Sheet.Panel>
        </Sheet>
    );
};

export default BoardLinkSheet;
